import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const CommonClass = twMerge(
  'fixed',
  'flex',
  'items-center',
  'space-x-4',
  'rounded-lg',
  'bottom-5',
  'right-5',
  'space-x',
  'z-1000'
);

export const toastVariants = cva(CommonClass, {
  variants: {
    variant: {
      error_sm: 'bg-emerge-base-2 text-error-darkred border border-error-darkred',
      success_sm: 'bg-emerge-teal-3 text-emerge-navy border border-emerge-teal',
      error: 'bg-emerge-base-2 text-error-darkred',
      success: 'bg-emerge-teal-3 text-emerge-navy',
      info: 'bg-emerge-base-3 shadow-lg',
      batch_complete: 'bg-emerge-base-3 text-emerge-navy backdrop-blur-sm',
      batch_incomplete: 'bg-aux-lightred text-error-darkred backdrop-blur-sm'
    },
    size: {
      sm: 'max-w-sm px-2 py-4 text-xs w-fit',
      md: 'max-w-80 p-4 w-full',
      lg: 'max-w-md p-4 text-sm w-full'
    }
  },
  defaultVariants: {
    variant: 'success',
    size: 'lg'
  }
});
